import { call, takeEvery } from 'typed-redux-saga'
import {
	notifyMessageCreator,
	feedbackModalApi,
	FeedbackModalStateNS,
	feedbackModalSlice,
	errorHandler,
} from 'Modules'

function* createOne(action: FeedbackModalStateNS.CreateOne) {
	try {
		yield* call(feedbackModalApi.createOne, action.payload)
		yield* call(notifyMessageCreator, 'modal.feedback_post.success')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* feedbackModalSaga() {
	yield* takeEvery(feedbackModalSlice.actions.createOne.type, createOne)
}
